/**
 * Database Abstraction Layer — Entry Point
 * Sprint 1, Story 1.1 / Activated Sprint 5/6 (EPIC-MG-001)
 *
 * Active adapter: ExpressDbAdapter — fala com /api/db/* endpoints do
 * Express usando query builder PostgREST-style. Substitui o supabaseDbAdapter
 * que apontava pro localhost:54321 (Supabase local).
 */

export type { DbClient, DbResult, DbError, DbQueryBuilder, DbTable, SelectOptions } from './types';
export { expressDbAdapter } from './express-adapter';

// ─── Active Database Client ───────────────────────────────────────────

import { expressDbAdapter } from './express-adapter';
import type { DbClient } from './types';

export const db: DbClient = expressDbAdapter;
